import styled from "styled-components";
import {
  PageBox,
  PageContentHeaderActionsWrapper,
  PageContentWrapper,
} from "../../../styles/page";

export const PageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 50px 0 30px;

  font-family: Pretendard;
`;

export const PageHeader = styled.div`
  position: relative;
  width: 100%;
  background: white;
  display: flex;
  justify-content: space-between;
  text-align: left;
  padding: 50px 30px 25px 0px;

  > .title {
    font-family: Pretendard;
    font-size: 35px;
    font-weight: 700;
  }
`;

export const SolutionHeaderInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
`;

export const SolutionHeaderInfo = styled.div`
  display: flex;
  gap: 20px;

  > div {
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 500;
    line-height: 17.9px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    > span {
      font-family: Pretendard;
      font-size: 15px;
      font-weight: 500;
      line-height: 17.9px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
  }
`;

export const SolutionHeaderButtonWrapper = styled.div`
  display: flex;
  gap: 20px;

  > .button {
    width: 176px;
    height: 50px;
    padding: 10px 12px 10px 12px;
    box-sizing: border-box;
    border-radius: 15px;
    background: #bebebe;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    color: #fff;
    cursor: pointer;

    &.purple {
      background: #7f25fb;
    }
  }
`;

export const SolutionHeaderWrapper = styled(PageBox)`
  display: flex;
  width: 100%;
  border: 0.93px solid #d9d9d9;
`;

export const SolutionCalenderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  width: 235px;
  height: 144px;
  text-align: left;
  justify-content: center;
  border-radius: 18px 0px 0px 18px;
  background: #7f25fb;
  font-family: Pretendard;
  font-size: 23.16px;
  font-weight: 700;
  color: #fff;
  line-height: 2;
  padding: 17px;
  box-sizing: border-box;

  > img {
    width: 13px;
    height: 8px;
    cursor: pointer;
  }
`;

export const SummaryBoxWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 10px;
  padding: 0 10px;
`;

export const SummaryBox = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 20px;
  width: auto;
  min-width: 500px;

  > .icon {
    width: 83px;
    height: 83px;
    border-radius: 20px;
    background: #ecf0f3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const SummaryBoxInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 80px;
  gap: 12px;

  > .name {
  }

  > .value {
    font-family: Pretendard;
    font-size: 30px;
    font-weight: 700;
    line-height: 35.8px;
    text-align: left;
    color: #ff0000;

    &.i0 {
      color: #7f25fb;
    }

    > span {
      font-family: Pretendard;
      font-size: 23.16px;
      font-weight: 700;
      color: #000;
    }
  }
`;

export const SummaryBoxMore = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;

  > img {
    width: 100%;
    height: 100%;
  }
`;

export const SummaryBoxPointTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  font-family: Pretendard;
  font-size: 23.16px;
  font-weight: 500;
  color: #121212;
  position: relative;
  padding-top: 5px;

  > .value1 {
    font-family: Pretendard;
    font-size: 23.16px;
    font-weight: 700;
    color: #ff0000;
  }

  > .value2 {
    font-family: Pretendard;
    font-size: 23.16px;
    font-weight: 700;
    color: #7f25fb;
  }
`;

export const SummaryBoxItemTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  font-family: Pretendard;
  font-size: 23.16px;
  font-weight: 700;
  color: #121212;
  position: relative;
  padding-top: 5px;

  &.point {
    font-family: Pretendard;
    font-size: 23.16px;
    font-weight: 500;

    > .value1 {
      font-family: Pretendard;
      font-size: 23.16px;
      font-weight: 700;
      color: #ff0000;
    }

    > .value2 {
      font-family: Pretendard;
      font-size: 23.16px;
      font-weight: 700;
      color: #7f25fb;
    }
  }
`;

export const SummaryBoxButton = styled.div<{ $disabled: boolean }>`
  width: max-content;
  height: 28px;
  border-radius: 10px;
  background: ${({ $disabled }) => ($disabled ? "#7F25FB" : "#ff0000")};
  color: #fff;
  font-family: Pretendard;
  font-size: 15px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  padding: 0px 12px;
`;

export const MoreInfoWrapper = styled.div`
  position: absolute;
  width: max-content;
  height: auto;
  padding: 20px;
  box-sizing: border-box;
  top: 20px;
  left: 50px;
  z-index: 100;

  > .name {
    font-family: Pretendard;
    font-size: 19px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  > .info {
    display: flex;
    flex-direction: column;
    gap: 12px;

    > .box {
      gap: 12px;
      display: flex;
      font-family: Pretendard;
      font-size: 15px;
      font-weight: 500;
      justify-content: space-between;
      white-space: nowrap;

      > .name {
        font-weight: 600;
      }
    }
  }
`;

export const SolutionTableWrapper = styled(PageContentWrapper)`
  padding: 4px 20px 20px;
  font-family: Pretendard;
  border-radius: 20px;
  height: auto;
  background: #ffffff;
  border: 2px solid #d9d9d9;
  box-shadow: 0px 3.71px 3.71px 0px #00000040;
  width: 100%;
  margin: 0;

  > .length {
    text-align: center;
    margin: 30px 0;
  }
`;

export const PageContentHeader = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding-bottom: 25px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #d9d9d9;
  font-family: Pretendard;
  font-size: 25px;
  font-weight: 600;
  line-height: 29.83px;
  text-align: left;
  margin-top: 25px;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const MainHeaderActionsWrapper = styled(PageContentHeaderActionsWrapper)`
  > .button {
    width: 176px;
    height: 50px;
    box-sizing: border-box;
    cursor: pointer;
    border-radius: 15px;
    background-color: #7f25fb;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 700;
    line-height: 50px;
  }
`;

export const PopupWrapper = styled.div`
  width: 1016px;
  height: auto;
  border-radius: 13px;
  background: #fff;
  position: fixed;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 4px 0px #00000040;
`;

export const SolutionContentWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto auto auto;
  margin-top: 18px;
  padding-bottom: 50px;

  .box1 {
    grid-column: 1;
    grid-row: 1;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .box2 {
    margin-right: 10px;
    margin-bottom: 10px;
    grid-column: 1;
    grid-row: 2;
  }

  .box3 {
    margin-right: 10px;
    margin-bottom: 10px;
    grid-column: 1;
    grid-row: 3;
  }

  .box4 {
    margin-right: 10px;
    grid-column: 1;
    grid-row: 4;
  }

  .box5 {
    grid-column: 2;
    grid-row: 1 / 5;
  }
`;
